"use client"

import { useState, useEffect } from "react"
import { Link, useParams, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Tab, Nav, Button, Modal } from "react-bootstrap"
import { Tooltip, OverlayTrigger } from "react-bootstrap"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import { Dropdown } from "react-bootstrap"
import LeadFollowUp from "./Components/LeadFollowUp.Component"
import TelecallerAppointmentCalendar from "../../Common/TelecallerAppointmentCalendar"
import QuestionnaireComponent from "./Components/Questionnaire.Component"
import { getLeadDetailsAction, updateLeadBranchAction } from "../../../../store/actions/LeadAction.js"
import { getDiseaseWiseScript } from "../../../../services/ScriptService.js"
import { assignLeadsToTelecaller, updatePanchkarmaExplained } from "../../../../services/LeadService"
import { getBranchesAction } from "../../../../store/actions/BranchAction"
import Loader from "../../Common/Loader.jsx"
import MarketingContent from "../../Common/MarketingContent.jsx"
import Notes from "./Components//LeadNotes.Component"
import CallLogs from "./Components/CallLogs.jsx"
import { formatName } from "../../../../utils/formatName.js"
//Images
import { FaAddressCard } from "react-icons/fa";
import icon from "../../../../../src/assets/images/icons8-call-102.png"
import defaultAvatar from "../../../../../src/assets/images/placeholder.jpg"
import avatar1 from "../../../../../src/assets/images/avatar/1.png"
import avatar2 from "../../../../../src/assets/images/avatar/2.png"
import avatar3 from "../../../../../src/assets/images/avatar/3.png"
import avatar4 from "../../../../../src/assets/images/avatar/4.png"
import { handleSuccess, showErrorAlert } from "../../../../services/ErrorHandlingService.js"
import { getObjections } from "../../../../services/ObjectionService"
import { getPatientObjectionsService, updatePatientObjectionsService } from "../../../../services/PatientObjectionService"
import OtherPersonalModal from "../../AppsMenu/Patients/Components/OtherPersonalModal.jsx"
import LeadPersonalModal from "../../AppsMenu/Patients/Components/LeadPersonalModal.jsx"
import PaymentDetails from "../../AppsMenu/Patients/Components/PaymentDetails.jsx"
import { sendFormLinkAction } from "../../../../store/actions/ReceptionistAction"
import { FaWhatsapp } from "react-icons/fa";
import axiosInstance from "../../../../services/AxiosInstance.js";
import swal from "sweetalert"

// import { fetchAppointmentsLeadAction } from "../../../../store/actions/AppointmentActions.js";


const ViewLead = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [branchUpdateLoading, setBranchUpdateLoading] = useState(false)
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [sentItems, setSentItems] = useState([])
  const leadDetails = useSelector((state) => state.leadState?.leadDetails)
  const branches = useSelector((state) => state.branches?.branches || [])
  const [selectedType, setSelectedType] = useState("")
  const [selectedDiseaseId, setSelectedDiseaseId] = useState([])
  // Shared disease selection across tabs
  const [selectedDiseases, setSelectedDiseases] = useState([]);
  const [showPersonalInfo, setShowPersonalInfo] = useState(true);
  const [diseaseScripts, setDiseaseScripts] = useState([])
  const diseases = useSelector((state) => state.diseases?.diseases || [])
  const [loadingScripts, setLoadingScripts] = useState(false)

  const location = useLocation() // Initialize useLocation
  const { fromLeadsTable, questionnaireFilledStatus, isConverted } = location.state || {}
  const patientDetails = useSelector((state) => state.patients.patientDetails);

  const patientId =
    location.state?.patient_id ||
    leadDetails?.patient_id ||
    patientDetails?.patient_id;

  console.log("🩺 Patient ID Source:", {
    fromLocation: location.state?.patient_id,
    fromLead: leadDetails?.patient_id,
    fromRedux: patientDetails?.patient_id,
    finalPatientId: patientId,
  });

  // Notes modal state
  const [showModal, setShowModal] = useState(false)
  const [noteDescription, setNoteDescription] = useState("")
  // other type
  const [showOtherModal, setShowOtherModal] = useState(false)

  const [otherPersonData, setOtherPersonData] = useState({})
  const { appointments } = useSelector((state) => state.appointmentState)
  console.log("Redux appointments:", appointments)
  const leadId = leadDetails?.lead_id || id
  // const { appointments } = useSelector((state) => state.appointment);
  // Unsaved changes warning state
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [showUnsavedWarning, setShowUnsavedWarning] = useState(false)
  const [pendingNavigation, setPendingNavigation] = useState(null)

  const handleShow = () => setShowModal(true)
  const handleClose = () => setShowModal(false)
  const latestAppointmentDoctorId =
    leadDetails?.AppointmentDetails?.[leadDetails.AppointmentDetails.length - 1]?.doctor_id || null
  const [isPersonalInfoModalOpen, setIsPersonalInfoModalOpen] = useState(false)
  const [sendingLinkLeadId, setSendingLinkLeadId] = useState(null)
  const handlePersonalInfoOpen = () => setIsPersonalInfoModalOpen(true)
  const handlePersonalInfoClose = () => setIsPersonalInfoModalOpen(false)
  const [panchkarmaBenefits, setPanchkarmaBenefits] = useState(false);
  const [panchkarmaLoading, setPanchkarmaLoading] = useState(false);
  const [intensityLoading, setIntensityLoading] = useState(false);
  const [selectedIntensity, setSelectedIntensity] = useState(null);

  // Objections (fetched from API like PatientsDetails)
  const [objections, setObjections] = useState([])
  const [objectionsLoading, setObjectionsLoading] = useState(false)
  const [objectionsError, setObjectionsError] = useState(null)
  const [selectedPatientObjections, setSelectedPatientObjections] = useState([])
  const [updatingPatientObjections, setUpdatingPatientObjections] = useState(false)


  // Form data state
  const [formData, setFormData] = useState({
    platforms: [],
    name: "",
    Contact: "",
    email: "",
    lead_photo: "",
    branch: "",
    additionalContact: "",
    dob: "",
    height: "",
    weight: "",
    occupation: "",
    married: false,
    marriageDate: "",
    spouseName: "",
    idProof: "",
    idNumber: "",
    tempAddressLine1: "",
    tempAddressLine2: "",
    tempArea: "",
    tempCity: "",
    tempState: "",
    tempPincode: "",
    addressLine1: "",
    addressLine2: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
  })
  const downloadVCF = () => {
    if (!formData?.name || !formData?.Contact) {
      showErrorAlert("Contact info not available");
      return;
    }

    const fullName = formData.name.trim();
    const nameParts = fullName.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    const vcf = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${lastName};${firstName};;;`,
      `FN:${fullName}`,
      `TEL;TYPE=CELL:${formData.Contact}`,
      formData.email ? `EMAIL:${formData.email}` : "",
      "END:VCARD"
    ]
      .filter(Boolean) // removes empty lines
      .join("\n");

    //    const blob = new Blob([vcf], { type: "text/vcard;charset=utf-8" });
    const blob = new Blob([vcf], { type: "text/x-vcard;charset=utf-8" });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${fullName.replace(/\s+/g, "_")}.vcf`;
    link.click();

    URL.revokeObjectURL(url);
  };


  // Tags state
  const [selectedTags, setSelectedTags] = useState([])
  const [shuffledTags, setShuffledTags] = useState([])

  const handlePopState = (e) => {
    if (hasUnsavedChanges) {
      // User is trying to use browser back/forward buttons
      e.preventDefault()
      setPendingNavigation("browser-navigation")
      setShowUnsavedWarning(true)
      // Push the current state back to prevent navigation
      window.history.pushState(null, "", window.location.href)
      return false
    }
  }

  // Handle unsaved changes warning
  const handleUnsavedChangesChange = (hasChanges) => {
    console.log("Unsaved changes state changed:", hasChanges)
    setHasUnsavedChanges(hasChanges)

    // Update browser tab title to indicate unsaved changes
    if (hasChanges) {
      document.title = document.title.replace(/^\*/, "") + " *"
    } else {
      document.title = document.title.replace(/\s*\*$/, "")
    }
  }

  // Handle navigation with unsaved changes
  const handleNavigationAttempt = (targetPath) => {
    if (hasUnsavedChanges) {
      setPendingNavigation(targetPath)
      setShowUnsavedWarning(true)
      return false
    }
    return true
  }

  // Handle confirmation to leave without saving
  const handleConfirmLeave = () => {
    setShowUnsavedWarning(false)
    setHasUnsavedChanges(false)
    if (pendingNavigation) {
      if (pendingNavigation === "browser-navigation") {
        // Remove popstate listener before going back
        window.removeEventListener("popstate", handlePopState)
        window.history.back()
      } else if (
        typeof pendingNavigation === "string" &&
        !pendingNavigation.startsWith("/") &&
        pendingNavigation !== "browser-navigation"
      ) {
        setActiveTab(pendingNavigation)
      } else if (pendingNavigation.startsWith("http") || pendingNavigation.startsWith("//")) {
        window.location.href = pendingNavigation
      } else {
        navigate(pendingNavigation)
      }
      setPendingNavigation(null)
    }
  }

  // Handle cancel navigation
  const handleCancelNavigation = () => {
    setShowUnsavedWarning(false)
    setPendingNavigation(null)
  }

  // Add event listeners for page refresh/close and external navigation
  useEffect(() => {
    console.log("Setting up navigation blockers, hasUnsavedChanges:", hasUnsavedChanges)

    const handleBeforeUnload = (e) => {
      console.log("beforeunload triggered, hasUnsavedChanges:", hasUnsavedChanges)
      if (hasUnsavedChanges) {
        // Modern browsers require preventDefault and returnValue
        e.preventDefault()
        e.returnValue = "You have unsaved changes. Please submit the form to save your progress."

        // For older browsers
        return "You have unsaved changes. Please submit the form to save your progress."
      }
    }

    // Alternative approach for browsers that don't support beforeunload properly
    const handleUnload = (e) => {
      if (hasUnsavedChanges) {
        console.log("unload event triggered with unsaved changes")
        // This is a fallback for browsers that don't respect beforeunload
        e.preventDefault()
        return false
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden" && hasUnsavedChanges) {
        // User is navigating away (tab switch, window minimize, etc.)
        // Note: We can't prevent this, but we can track it
        console.log("User navigating away with unsaved changes")
      }
    }

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload)
    window.addEventListener("unload", handleUnload)
    document.addEventListener("visibilitychange", handleVisibilityChange)
    window.addEventListener("popstate", handlePopState)

    // Also set the onbeforeunload property for better compatibility
    if (hasUnsavedChanges) {
      window.onbeforeunload = handleBeforeUnload
    } else {
      window.onbeforeunload = null
    }

    // Push current state to enable popstate detection
    window.history.pushState(null, "", window.location.href)

    // Handle external link clicks
    const handleLinkClick = (e) => {
      const target = e.target.closest("a")
      if (target && hasUnsavedChanges) {
        const href = target.getAttribute("href")
        const targetUrl = target.getAttribute("target")

        console.log("Link clicked:", href, "target:", targetUrl, "hasUnsavedChanges:", hasUnsavedChanges)

        // Check if it's an external link or opens in new tab/window
        if (href && (href.startsWith("http") || href.startsWith("//") || targetUrl === "_blank")) {
          e.preventDefault()
          setPendingNavigation(href)
          setShowUnsavedWarning(true)
        }
      }
    }

    // Handle form submissions that might navigate away
    const handleFormSubmit = (e) => {
      if (hasUnsavedChanges) {
        const form = e.target.closest("form")
        if (form && form.action && (form.action.startsWith("http") || form.action.startsWith("//"))) {
          e.preventDefault()
          setPendingNavigation(form.action)
          setShowUnsavedWarning(true)
        }
      }
    }

    document.addEventListener("click", handleLinkClick)
    document.addEventListener("submit", handleFormSubmit)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
      window.removeEventListener("unload", handleUnload)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      window.removeEventListener("popstate", handlePopState)
      document.removeEventListener("click", handleLinkClick)
      document.removeEventListener("submit", handleFormSubmit)
      window.onbeforeunload = null
    }
  }, [hasUnsavedChanges])

  // Override navigate function to check for unsaved changes
  const safeNavigate = (path) => {
    if (handleNavigationAttempt(path)) {
      navigate(path)
    }
  }

  // For Back button only
  const handleBackNavigationAttempt = () => {
    return true // always allow back navigation
  }

  const safeBackNavigate = (path) => {
    if (handleBackNavigationAttempt()) {
      navigate(path)
    }
  }
  const intensityOptions = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
    { value: "very-high", label: "Very High" },
  ];
  const availableTags = [
    "Script",
    "Questionnaire",
    "Appointment",
    "Notes",
    "Call Logs",
    "Follow Up",
    "Marketing",
    "Disease",
    "Feedback",
    "Campaign",
    "Interested",
  ]

  useEffect(() => {
    if (leadDetails && diseases.length > 0) {
      const leadDiseaseIds = (leadDetails.diseases || []).map((d) => String(d.disease_id))
      setSelectedDiseaseId(leadDiseaseIds)

      const preSelected = diseases
        .filter((d) => leadDiseaseIds.includes(String(d.disease_id)))
        .map((d) => ({
          value: String(d.disease_id),
          label: d.disease_name,
        }))

      setSelectedDiseases(preSelected)
    }
  }, [leadDetails, diseases])

  // Sync panchkarma_explained from leadDetails
  useEffect(() => {
    if (leadDetails?.panchkarma_explained) {
      setPanchkarmaBenefits(leadDetails.panchkarma_explained === "Yes" || leadDetails.panchkarma_explained === true)
    }
  }, [leadDetails])

  useEffect(() => {
    const shuffled = [...availableTags].sort(() => Math.random() - 0.5).map((tag) => ({ value: tag, label: tag }))
    setShuffledTags(shuffled)
  }, [])

  useEffect(() => {
    if (id) {
      setIsLoading(true)
      Promise.all([dispatch(getLeadDetailsAction(id)), dispatch(getBranchesAction(false))])
        .then(() => {
          handleSuccess("Lead details loaded successfully")
        })
        .catch((error) => {
          console.error("Failed to load lead data:", error)
          showErrorAlert("Failed to load lead data: " + error.message)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [dispatch, id])

  useEffect(() => {
    if (leadDetails && id) {
      const {
        lead_id,
        first_name,
        middile_name,
        last_name,
        id: uniqueId,
        full_name,
        phone_no,
        additional_contact_no,
        lead_photo,
        email,
        date_of_birth,
        height,
        weight,
        occupation,
        id_proof,
        id_number,
        gender,
        diseases,
        MarriageInfo,
        TemporaryAddress,
        PermanentAddress,
        ad_name,
        adset_name,
        campaign_name,
        lead_source,
        lead_status,
        priority,
        comment,
        branch_id,
        lead_for,
        other_first_name,
        other_middile_name,
        other_last_name,
        other_email,
        other_whatsapp_contact_no,
        other_additional_contact_no,
        other_gender,
        other_date_of_birth,
        intensity_of_treatment,
      } = leadDetails

      const diseaseNames = diseases && diseases.length > 0 ? diseases.map((d) => d.disease_name).join(" | ") : ""

      setFormData({
        lead_id: lead_id || id,
        uniqueId: uniqueId || "",
        name: formatName(`${first_name || ""} ${middile_name || ""} ${last_name || ""}`.trim()),
        Contact: phone_no || "",
        lead_photo: lead_photo || "",
        email: email || "",
        additionalContact: additional_contact_no || "",
        dob: date_of_birth || "",
        height: height || "0",
        weight: weight || "0",
        occupation: occupation || "",
        idProof: id_proof || "",
        idNumber: id_number || "",
        gender: gender || "",
        Disease: diseaseNames,
        diseases: diseases || [],

        marriageInfo: MarriageInfo || [],
        marriageDate: MarriageInfo?.[0]?.date_of_marriage || "",
        spouseName1: formatName(MarriageInfo?.[0]?.husband_or_spouse_name || ""),
        tempAddressLine1: TemporaryAddress?.address_line1 || "",
        tempAddressLine2: TemporaryAddress?.address_line2 || "",
        tempArea: TemporaryAddress?.area || "",
        tempCity: TemporaryAddress?.city || "",
        tempPincode: TemporaryAddress?.pincode || "",
        tempState: TemporaryAddress?.state || "",
        permAddressLine1: PermanentAddress?.address_line1 || "",
        permAddressLine2: PermanentAddress?.address_line2 || "",
        permArea: PermanentAddress?.area || "",
        permCity: PermanentAddress?.city || "",
        permPincode: PermanentAddress?.pincode || "",
        permState: PermanentAddress?.state || "",
        adName: ad_name || "",
        adSet: adset_name || "",
        campaignName: campaign_name || "",
        leadSource: lead_source || "",
        status: lead_status || "",
        priority: priority || "",
        comment: comment || "",
        branch_id: branch_id || "",
        leadFor: lead_for || "Self",
      })
      if (intensity_of_treatment) {
        const matchedOption = intensityOptions.find(
          (opt) => opt.value === intensity_of_treatment
        )

        setSelectedIntensity(matchedOption || null)
      }
      if (lead_for === "Other") {
        setOtherPersonData({
          first_name: formatName(other_first_name || ""),
          middle_name: formatName(other_middile_name || ""),
          last_name: formatName(other_last_name || ""),
          contact: other_whatsapp_contact_no || "",
          email: other_email || "",
          gender: other_gender || "",
          date_of_birth: other_date_of_birth || "",
        })
      } else {
        // Clear otherPersonData if lead_for is not "Other"
        setOtherPersonData({})
      }
      setSelectedType(lead_for || "Self")
    }
  }, [leadDetails, id])

  useEffect(() => {
    if (leadDetails && branches.length > 0) {
      const currentBranch = branches.find((b) => b.branch_id === leadDetails.branch_id)
      if (currentBranch) {
        setSelectedBranch({
          value: currentBranch.branch_id,
          label: currentBranch.branch_name,
        })
      }
    }
  }, [leadDetails, branches])

  // Fetch objections list (master) and patient-specific objections when patientId available
  useEffect(() => {
    const fetchObjectionsData = async () => {
      try {
        setObjectionsLoading(true)
        setObjectionsError(null)
        const response = await getObjections(false, 0, "", "", "", "")

        if (response?.data?.data) {
          const objectionList = Array.isArray(response.data.data) ? response.data.data : [response.data.data]
          setObjections(objectionList)
        }
      } catch (error) {
        console.error("Error fetching objections:", error)
        setObjectionsError(error.message)
      } finally {
        setObjectionsLoading(false)
      }
    }

    fetchObjectionsData()
  }, [])

  // Fetch patient objections (if patientId present)
  useEffect(() => {
    const fetchPatientObjections = async () => {
      if (!leadId) return
      try {
        const res = await getPatientObjectionsService(null, leadId)
        if (res?.data?.data) {
          const patientObjList = Array.isArray(res.data.data) ? res.data.data : [res.data.data]
          setSelectedPatientObjections(patientObjList)
        }
      } catch (err) {
        console.error("Error fetching patient objections:", err)
      }
    }

    fetchPatientObjections()
  }, [patientId])

  // Toggle / update patient objections
  const handlePatientObjectionChange = async (objection) => {
    try {
      setUpdatingPatientObjections(true)

      const objectionId = objection.objection_id || objection.id
      let updatedObjections

      const isSelected = selectedPatientObjections.some((obj) => (obj.objection_id || obj.id) === objectionId)

      if (isSelected) {
        updatedObjections = selectedPatientObjections.filter((obj) => (obj.objection_id || obj.id) !== objectionId)
      } else {
        updatedObjections = [...selectedPatientObjections, objection]
      }

      const objectionIds = updatedObjections.map((obj) => obj.objection_id || obj.id)

      // Only update if we have a leadId
      if (!leadId) {
        // For leads without patient mapping, keep local state only
        setSelectedPatientObjections(updatedObjections)
        return
      }

      const response = await updatePatientObjectionsService(null, objectionIds, leadId)

      if (response) {
        setSelectedPatientObjections(updatedObjections)
        handleSuccess("Objection updated successfully")
      }
    } catch (error) {
      console.error("Error updating patient objections:", error)
      showErrorAlert(error.response?.data?.message || "Failed to update objection")
    } finally {
      setUpdatingPatientObjections(false)
    }
  }
  // State for active tab, initialized based on navigation state
  const [activeTab, setActiveTab] = useState("Script") // Default to Questionnaire
  const [questionnaireSubmitted, setQuestionnaireSubmitted] = useState(() => {
    // Check localStorage for persisted submission state
    const savedState = localStorage.getItem(`questionnaire_submitted_${leadId}`)
    return savedState === "true"
  })

  // useEffect(() => {
  //   if (leadId) {
  //     console.log("Fetching appointments for lead:", leadId);
  //     dispatch(fetchAppointmentsLeadAction(leadId));
  //   }
  // }, [leadId, dispatch]);

  // useEffect(() => {
  //   console.log("Redux appointments updated:", appointments);
  // }, [appointments]);

  useEffect(() => {
    if (fromLeadsTable && questionnaireFilledStatus?.toLowerCase() === "no") {
      setActiveTab("Script")
    }
  }, [fromLeadsTable, questionnaireFilledStatus])
  // Handle tag selection
  const handleTagToggle = (tag) => {
    setSelectedTags((prev) => {
      const isSelected = prev.some((t) => t.value === tag.value)
      if (isSelected) {
        return prev.filter((t) => t.value !== tag.value)
      } else {
        return [...prev, tag]
      }
    })
  }
  useEffect(() => {
    if (selectedDiseaseId.length > 0) {
      ; (async () => {
        try {
          const res = await getDiseaseWiseScript(selectedDiseaseId)
          if (res.data.status === "success") {
            setDiseaseScripts(res.data.data || [])
          } else {
            setDiseaseScripts([])
          }
        } catch (error) {
          console.error("Error fetching scripts:", error)
          setDiseaseScripts([])
        }
      })()
    }
  }, [selectedDiseaseId])

  const handleDiseaseChange = async (selectedOptions) => {
    setSelectedDiseases(selectedOptions || []); // store selected options
    const ids = (selectedOptions || []).map((option) => String(option.value));
    setSelectedDiseaseId(ids);

    setLoadingScripts(true);

    try {
      const res = await getDiseaseWiseScript(ids);
      if (res.data.status === "success") {
        const nonEmptyScripts = res.data.data.filter((d) => d.scripts?.length > 0);
        setDiseaseScripts(nonEmptyScripts);
      } else {
        setDiseaseScripts([]);
      }
    } catch (error) {
      console.error("Failed to fetch disease scripts:", error);
      setDiseaseScripts([]);
    } finally {
      setLoadingScripts(false);
    }
  };

  const handleIntensityChange = async (selectedOption) => {

    if (!selectedOption) {
      setSelectedIntensity(null);
      return;
    }

    try {
      setIntensityLoading(true);   // ✅ start loader
      setSelectedIntensity(selectedOption);

      if (!leadId) {
        showErrorAlert("Lead ID missing");
        return;
      }

      const payload = new FormData();
      payload.append("lead_id", leadId);
      payload.append("intensity_of_treatment", selectedOption.value);

      const response = await axiosInstance.post(
        "/lead/updateLeadIntensity",
        payload
      );

      if (response?.data?.status === "success") {
        handleSuccess(response?.data?.message);
      } else {
        throw new Error(response?.data?.message);
      }

    } catch (error) {
      console.error("Intensity update error:", error);

      showErrorAlert(
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    } finally {
      setIntensityLoading(false);   // ✅ stop loader
    }
  };


  // Handle Panchkarma Benefits checkbox
  const handlePanchkarmaChange = async (isChecked) => {
    try {
      setPanchkarmaLoading(true)
      setPanchkarmaBenefits(isChecked)

      const response = await updatePanchkarmaExplained(id, isChecked)

      if (response?.data?.status === "success") {
        handleSuccess(isChecked ? "Panchkarma benefits marked as explained" : "Panchkarma benefits unmarked")
      } else {
        showErrorAlert(response?.data?.message || "Failed to update Panchkarma status")
        setPanchkarmaBenefits(!isChecked) // Revert on error
      }
    } catch (error) {
      console.error("Error updating Panchkarma status:", error)
      showErrorAlert("Failed to update Panchkarma status")
      setPanchkarmaBenefits(!isChecked) // Revert on error
    } finally {
      setPanchkarmaLoading(false)
    }
  }

  // Handle notes
  const handleAddNote = () => {
    console.log("Note Added:", noteDescription)
    setNoteDescription("")
    handleClose()
    handleSuccess("Note added successfully")
  }

  // Handle questionnaire submission

  const handleQuestionnaireSubmit = (formData) => {
    console.log("Questionnaire submitted:", formData)
    handleSuccess("Questionnaire submitted successfully!")
    setQuestionnaireSubmitted(true)
    setHasUnsavedChanges(false)
    setShowUnsavedWarning(false)
    setPendingNavigation(null)
    document.title = document.title.replace(/\s*\*$/, "")

    // Persist submission state to localStorage
    localStorage.setItem(`questionnaire_submitted_${leadId}`, "true")
  }

  const handleWhatsAppClick = (explicitNumber) => {
    // prefer explicitNumber passed from caller, else try common fields
    const raw =
      explicitNumber ||
      formData?.whatsapp_contact_no ||
      formData?.Contact ||
      formData?.additionalContact ||
      "";

    if (!raw) {
      alert("WhatsApp number not available");
      return;
    }

    // keep only digits
    let cleaned = String(raw).replace(/\D/g, "");

    // if number begins with 0 remove leading zeros
    cleaned = cleaned.replace(/^0+/, "");

    // If 10 digits (likely local India mobile), prepend country code 91.
    // Adjust/remove this heuristic if your data has country codes already or different country.
    if (cleaned.length === 10) {
      cleaned = "91" + cleaned;
    }

    // final basic validation (min 10 digits after cleaning)
    if (cleaned.length < 10) {
      alert("Invalid WhatsApp number");
      return;
    }

    // Open WhatsApp (works for mobile + web)
    const waUrl = `https://wa.me/${cleaned}`;
    window.open(waUrl, "_blank", "noopener,noreferrer");
  };

  const handlePickLead = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"))
    const admin_id = userDetails?.admin_id
    const role_name = userDetails?.role_name || ""

    if (!admin_id || !leadDetails?.lead_id) {
      showErrorAlert("Missing lead ID or telecaller ID")
      return
    }

    const payload = {
      lead_ids: JSON.stringify([leadDetails.lead_id]),
      telecaller_id: admin_id,
    }

    try {
      const res = await assignLeadsToTelecaller(payload)
      handleSuccess("Lead picked successfully")
      console.log("Lead assigned:", res.data)
    } catch (error) {
      showErrorAlert("Failed to assign lead")
      console.error("Error assigning lead:", error)
    }
  }

  // Content items for marketing
  const contentItems = [
    {
      id: 1,
      title: "Video 1",
      type: "Video",
      avatar: avatar1,
      disease: "Diabetes",
    },
    {
      id: 2,
      title: "Image 1",
      type: "Image",
      avatar: avatar2,
      disease: "Hypertension",
    },
    {
      id: 3,
      title: "Video 2",
      type: "Video",
      avatar: avatar3,
      disease: "Asthma",
    },
    {
      id: 4,
      title: "Image 2",
      type: "Image",
      avatar: avatar4,
      disease: "Heart Disease",
    },
  ]

  const handleTypeSelection = (type) => {
    setSelectedType(type)

    if (type === "Other") {
      setShowOtherModal(true)
    }
  }

  const handleOtherModalClose = () => {
    setShowOtherModal(false)
  }

  const handleOtherModalSubmit = (formData) => {
    setOtherPersonData(formData)
    console.log("Other person data:", formData)
    // Handle the form data as needed
  }

  const handleSend = (id, title) => {
    handleSuccess(`Content "${title}" sent successfully`)
    setSentItems((prev) => [...prev, id])
  }
  const handlePersonalInfoSubmit = (updatedData) => {
    setFormData((prev) => ({ ...prev, ...updatedData }))
    handleSuccess("Personal information updated successfully")
    handlePersonalInfoClose()
    // refetch to sync other slices if needed:
    if (id) dispatch(getLeadDetailsAction(id))
  }

  const sendLinkForm = async (patientId) => {
    // patientId === lead.patient_id
    if (!patientId) return // guard against null
    setSendingLinkLeadId(patientId) // show loader for this row
    try {
      await dispatch(sendFormLinkAction(patientId)) // thunk → API
      swal("Success", "Form link sent successfully!", "success")
    } catch (err) {
      swal("Error", "Failed to send form link", "error")
    } finally {
      setSendingLinkLeadId(null) // hide loader
    }
  }
  // Handle branch update
  const handleBranchUpdate = async (selectedOption) => {
    try {
      setBranchUpdateLoading(true)
      await dispatch(
        updateLeadBranchAction({
          lead_id: id,
          branch_id: selectedOption.value,
        }),
      )
      setSelectedBranch(selectedOption)
      handleSuccess("Branch updated successfully")
    } catch (error) {
      showErrorAlert(error.message || "Failed to update branch")
    } finally {
      setBranchUpdateLoading(false)
    }
  }
  const tabStyle = (key) => ({
    backgroundColor: activeTab === key ? "#005f66" : "transparent",
    color: activeTab === key ? "#ffffff" : "#005f66",
    borderRadius: "6px",
    transition: "all 0.2s ease-in-out",
    padding: "10px 18px",
    fontSize: "20px",
    fontWeight: "600",
  });

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        {/* {JSON.parse(localStorage.getItem("userDetails"))?.role_name === "Telecaller" &&
          leadDetails?.lead_assigned === "0" && (
            <Button variant="success" className="me-2" onClick={() => handlePickLead()}>
              Pick
            </Button>
          )} */}

        {/* <Button variant="primary" onClick={() => safeBackNavigate("/app-leads")}>
          Back
        </Button> */}
      </div>

      <div className="row">
        <div className="container-fluid px-4" style={{ paddingTop: "-60px", marginTop: "-60px", boxSizing: "border-box" }}>
          <div className="row">
            {/* <div className="col-xl-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body p-4">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="fs-18 text-black font-w600 mb-0">Tags</h4>
                      </div>
                      <div className="d-flex flex-wrap">
                        {shuffledTags.map((tag) => {
                          const isSelected = selectedTags.some((t) => t.value === tag.value)
                          return (
                            <div
                              key={tag.value}
                              className={`badge me-2 mb-2 d-flex align-items-center justify-content-center m-2 ${
                                isSelected ? "selected" : ""
                              }`}
                              onClick={() => handleTagToggle(tag)}
                              role="button"
                              tabIndex={0}
                              onKeyPress={(e) => e.key === "Enter" && handleTagToggle(tag)}
                              style={{
                                backgroundColor: isSelected ? "#007680" : "#f0fff4",
                                color: isSelected ? "#fff" : "#000",
                                height: "40px",
                                padding: "0 15px",
                                fontSize: "16px",
                                minWidth: "120px",
                                borderRadius: "20px",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                              }}
                            >
                              {tag.label}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-xl-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body pt-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="mb-0">Personal Information</h4>

                        <i
                          className={`fa ${showPersonalInfo ? "fa-chevron-up" : "fa-chevron-down"} fs-4`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowPersonalInfo(prev => !prev)}
                        ></i>

                      </div>
                      {showPersonalInfo && (
                        <>
                          <div className="media d-sm-flex d-block text-center text-sm-start pb-4 mb-4 border-bottom">
                            {/* Profile Image */}
                            <img
                              alt=""
                              className="rounded me-sm-4 me-0"
                              width={100}
                              src={formData.lead_photo || defaultAvatar}
                              onError={(e) => {
                                e.target.onerror = null
                                e.target.src = defaultAvatar
                              }}
                            />

                            <div className="media-body align-items-center">
                              <div className="d-sm-flex d-block justify-content-between my-3 my-sm-0">
                                {/* Name + Call icon */}
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                  <h3 className="fs-22 text-black font-w600 mb-0">{formData.name}</h3>
                                </div>

                                {/* Edit Icon */}
                                <span className="d-inline-flex align-items-center gap-2 me-3">

                                  {formData.Contact && (
                                    <a
                                      href={`https://wa.me/${formData.Contact}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      title="WhatsApp"
                                    >

                                    </a>
                                  )}
                                  {formData.Contact && (
                                    <a href={`tel:${formData.Contact}`} title="Call">
                                      <img
                                        className="me-2"
                                        src={icon || "/placeholder.svg"}
                                        alt="Call"
                                        style={{ width: "26px", height: "26px", cursor: "pointer" }}
                                      />
                                    </a>
                                  )}
                                  <Link
                                    to="#"
                                    onClick={handlePersonalInfoOpen}
                                    className="edit-staff"
                                    title="Edit Personal Info"
                                  >
                                    <i className="fa fa-pencil fs-18 text-success"></i>
                                  </Link>
                                </span>
                              </div>

                              {/* Gender Badge + ID */}
                              {/* <div className="d-flex align-items-center flex-wrap mt-3"> */}
                              <div className="d-flex align-items-center gap-3">
                                {formData.gender && (
                                  <Link to="#" className="btn bgl-primary btn-rounded text-black " title={formData.gender ? ` ${formData.gender}` : "No gender selected"}>
                                    {formData.gender === "Male" && (
                                      <>
                                        <svg
                                          className="me-2 scale5"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M14 2H22V10H20V5.41L15.71 9.71C16.45 10.79 16.91 12.1 16.98 13.5C17.17 17.14 14.32 20.24 10.68 20.48C6.79 20.74 3.5 17.6 3.5 13.71C3.5 9.82 6.65 6.53 10.54 6.29C11.94 6.2 13.25 6.66 14.34 7.41L18.59 3H14V2Z"
                                            fill="#2BC155"
                                          />
                                        </svg>
                                        M
                                      </>
                                    )}
                                    {formData.gender === "Female" && (
                                      <>
                                        <svg
                                          className="me-2 scale5"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M12 2C8.13 2 5 5.13 5 9C5 12.52 7.61 15.44 11 15.93V18H8V20H11V22H13V20H16V18H13V15.93C16.39 15.44 19 12.52 19 9C19 5.13 15.87 2 12 2ZM12 13C9.24 13 7 10.76 7 8C7 5.24 9.24 3 12 3C14.76 3 17 5.24 17 8C17 10.76 14.76 13 12 13Z"
                                            fill="#C92A2A"
                                          />
                                        </svg>
                                        F
                                      </>
                                    )}
                                    {formData.gender === "Transgender" && (
                                      <>
                                        <svg
                                          className="me-2 scale5"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M19 3h-2.59l1.3 1.29-2.83 2.83c-.85-.54-1.84-.87-2.88-.98V4h1V2h-4v2h1v2.14c-2.79.47-5 2.93-5 5.86 0 3.31 2.69 6 6 6 .57 0 1.11-.08 1.63-.24l1.63 1.63V20h-2v2h4v-2h-1v-1.17l-1.41-1.41c1.48-.98 2.46-2.65 2.46-4.59 0-1.04-.29-2.02-.78-2.85l2.83-2.83L21 6.59V4h-2V3zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                                            fill="#C92A2A"
                                          />
                                        </svg>
                                        Trans
                                      </>
                                    )}
                                  </Link>
                                )}
                                <FaAddressCard
                                  size={40}
                                  style={{
                                    cursor: "pointer",
                                    padding: "4px",
                                    // marginLeft: "25px",
                                    borderRadius: "6px",
                                    transition: "0.2s",
                                  }}
                                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f2f2f2")}
                                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                  onClick={downloadVCF}
                                  title="Download Contact (.vcf)"
                                />
                                <FaWhatsapp
                                  size={26}
                                  color="#25D366"
                                  title="Whatsapp"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleWhatsAppClick(formData.whatsapp_contact_no || formData.Contact || formData.additionalContact)}
                                />
                                {/* <span className="fw-bold ms-2">ID No: {formData.uniqueId || "-"}</span> */}
                              </div>
                            </div>
                          </div>

                          <div className="row gy-3">
                            <div className="col-lg-6">
                              <h5 className="f-w-500">Address:</h5>
                              <span>{formData.permAddressLine1 || formData.tempAddressLine1 || "-"}</span>
                            </div>

                            <div className="col-lg-6">
                              <h5 className="f-w-500">WhatsApp Phone Number:</h5>
                              <span>{formData.Contact || "-"}</span>
                            </div>

                            <div className="col-lg-6">
                              <h5 className="f-w-500">Email:</h5>
                              <span>{formData.email || "-"}</span>
                            </div>

                            <div className="col-lg-6">
                              <h5 className="f-w-500">Disease:</h5>
                              <span>{formData.Disease || "N/A"}</span>
                            </div>

                            {/* Branch */}
                            <div className="col-lg-6">
                              <h5 className="f-w-500">Branch Name:</h5>
                              <Select
                                value={selectedBranch}
                                onChange={handleBranchUpdate}
                                options={branches.map((branch) => ({
                                  value: branch.branch_id,
                                  label: branch.branch_name,
                                }))}
                                isLoading={branchUpdateLoading}
                                placeholder="Select Branch"
                                classNamePrefix="select"
                                menuPortalTarget={document.body}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "100%",
                                  }),
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: "55px",
                                    fontSize: "15px",
                                    borderRadius: "0.5rem",
                                    border: state.isFocused ? "1px solid #007bff" : "1px solid #ddd",
                                    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            </div>

                            {/* Type Dropdown */}
                            <div className="col-lg-6">
                              <h5 className="f-w-500">Lead for </h5>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  leadDetails?.lead_status === "Converted" ? (
                                    <Tooltip id="tooltip-disabled">This lead has been converted</Tooltip>
                                  ) : (
                                    <></>
                                  )
                                }
                              >
                                <span className="d-inline-block" style={{ width: "100%" }}>
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="outline-primary"
                                      id="dropdown-basic"
                                      disabled={leadDetails?.lead_status === "Converted"} // disable if converted
                                      style={
                                        leadDetails?.lead_status === "Converted"
                                          ? { pointerEvents: "none" } // ensures tooltip still works on disabled button
                                          : {}
                                      }
                                    >
                                      {selectedType === "Self" ? "Self" : "Other"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item onClick={() => handleTypeSelection("Self")}>Self</Dropdown.Item>
                                      <Dropdown.Item onClick={() => handleTypeSelection("Other")}>Other</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </span>
                              </OverlayTrigger>
                            </div>
                            <div className="col-lg-6">
                              <h5 className="f-w-500">Intensity of Treatment</h5>
                              <Select
                                options={intensityOptions}
                                value={selectedIntensity}
                                onChange={handleIntensityChange}
                                placeholder="Select intensity..."
                                isClearable
                                isLoading={intensityLoading}
                                isDisabled={intensityLoading}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "100%",
                                  }),
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: "55px",
                                    fontSize: "15px",
                                    borderRadius: "0.5rem",
                                    border: state.isFocused ? "1px solid #007bff" : "1px solid #ddd",
                                    boxShadow: state.isFocused
                                      ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                      : "none",
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />

                            </div>
                            <OtherPersonalModal
                              isOpen={showOtherModal}
                              onClose={handleOtherModalClose}
                              formData={otherPersonData}
                              onSubmit={handleOtherModalSubmit}
                            />
                          </div>
                        </>
                      )}

                    </div>
                  </div>
                  {/* leadpersonalmodal */}
                  <LeadPersonalModal
                    isOpen={isPersonalInfoModalOpen}
                    onClose={handlePersonalInfoClose}
                    formData={formData}
                    onSubmit={handlePersonalInfoSubmit}
                  />
                </div>
              </div>
            </div>

            <div className="col-xl-8">
              <div className="card" style={{ width: "100%" }}>
                <div className="card-body">
                  <div className="profile-tab">
                    {/* <div className="custom-tab-1">
                      <Tab.Container
                        activeKey={activeTab}
                        onSelect={(selectedKey) => {
                          if (selectedKey === "Questionnaire") {
                            setActiveTab(selectedKey)
                            return
                          }

                          // Only show modal if questionnaire is not submitted AND has unsaved changes
                          if (!questionnaireSubmitted && hasUnsavedChanges) {
                            setPendingNavigation(selectedKey)
                            setShowUnsavedWarning(true)
                            return
                          }

                          setActiveTab(selectedKey)
                        }}
                      >
                        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                          <Nav
                            as="ul"
                            className="nav nav-tabs flex-nowrap"
                            style={{
                              minWidth: "max-content",
                              borderBottom: "1px solid #dee2e6",
                            }}
                          >
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Script">Script</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Questionnaire">
                                Questionnaire
                                {!questionnaireSubmitted && hasUnsavedChanges && (
                                  <span className="badge bg-warning text-dark ms-2">Unsaved</span>
                                )}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Appointments">Appointments</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Notes">Notes</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Call-logs">Call-Logs</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Follow-up">Follow-Up</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Marketing-Content">Marketing Content</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Payment">Payment Details</Nav.Link>
                            </Nav.Item> 
                          </Nav>
                        </div> */}
                    <div className="custom-tab-1">
                      <Tab.Container
                        activeKey={activeTab}
                        onSelect={(selectedKey) => {
                          if (selectedKey === "Questionnaire") {
                            setActiveTab(selectedKey)
                            return
                          }

                          // Only show modal if questionnaire is not submitted AND has unsaved changes
                          if (!questionnaireSubmitted && hasUnsavedChanges) {
                            setPendingNavigation(selectedKey)
                            setShowUnsavedWarning(true)
                            return
                          }

                          setActiveTab(selectedKey)
                        }}
                      >
                        {/* ✅ Removed overflowX and nowrap; added wrapping */}
                        {/* <div style={{ whiteSpace: "normal" }}>
                          <Nav
                            as="ul"
                            className="nav nav-tabs flex-wrap justify-content-start"
                            style={{
                              borderBottom: "1px solid #dee2e6",
                              rowGap: "8px", // adds space between wrapped rows
                            }}
                          >
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Script">Script</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Questionnaire">
                                Questionnaire
                                {!questionnaireSubmitted && hasUnsavedChanges && (
                                  <span className="badge bg-warning text-dark ms-2">Unsaved</span>
                                )}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Appointments">Appointments</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Notes">Notes</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Call-logs">Call-Logs</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Follow-up">Follow-Up</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Marketing-Content">Marketing Content</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Objection">Objection</Nav.Link>
                            </Nav.Item>
                            {/* <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="Payment">Payment Details</Nav.Link>
        </Nav.Item> 
                          </Nav>
                          
                        </div> */}<div style={{ whiteSpace: "normal" }}>
                          <Nav
                            as="ul"
                            className="nav nav-tabs flex-wrap justify-content-start"
                            style={{
                              borderBottom: "1px solid #dee2e6",
                              rowGap: "8px",
                            }}
                          >
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Script"
                                style={tabStyle("Script", activeTab)}
                              >
                                Script
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Questionnaire"
                                style={tabStyle("Questionnaire", activeTab)}
                              >
                                Questionnaire
                                {!questionnaireSubmitted && hasUnsavedChanges && (
                                  <span className="badge bg-warning text-dark ms-2">Unsaved</span>
                                )}
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Appointments"
                                style={tabStyle("Appointments", activeTab)}
                              >
                                Appointments
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Notes"
                                style={tabStyle("Notes", activeTab)}
                              >
                                Notes
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Call-logs"
                                style={tabStyle("Call-logs", activeTab)}
                              >
                                Call-Logs
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Follow-up"
                                style={tabStyle("Follow-up", activeTab)}
                              >
                                Follow-Up
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Marketing-Content"
                                style={tabStyle("Marketing-Content", activeTab)}
                              >
                                Marketing Content
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link
                                eventKey="Objection"
                                style={tabStyle("Objection", activeTab)}
                              >
                                Objection
                              </Nav.Link>
                            </Nav.Item>

                          </Nav>
                        </div>


                        <Tab.Content>
                          {/* <Tab.Pane eventKey="Script">
                            {diseases?.length > 0 ? (
                              <>
                                <div className="mb-4 pt-4 px-3 pb-3 border rounded">
                                  <h5 className="mb-2">Select Disease(s) to View Script</h5>
                                  <Select
                                    isMulti
                                    options={diseases.map((d) => ({
                                      value: String(d.disease_id),
                                      label: d.disease_name,
                                    }))}
                                    value={diseases
                                      .filter((d) => selectedDiseaseId.includes(String(d.disease_id)))
                                      .map((d) => ({
                                        value: String(d.disease_id),
                                        label: d.disease_name,
                                      }))
                                    }
                                    onChange={handleDiseaseChange}
                                    placeholder="Choose disease(s)..."
                                    classNamePrefix="select"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        minHeight: "50px",
                                        fontSize: "14px",
                                        borderRadius: "0.5rem",
                                        borderColor: state.isFocused ? "#007bff" : "#ced4da",
                                        boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>

                                {loadingScripts ? (
                                  <div className="text-center my-4">
                                    <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                  </div>
                                ) : diseaseScripts.length === 0 ? (
                                  <div className="text-muted mt-3">No scripts found for selected diseases.</div>
                                ) : (
                                  <div className="mt-3">
                                    {diseaseScripts.map((disease, index) => (
                                      <div key={index} className="mb-4">
                                        <h6 className="fw-bold">{disease.disease_name}</h6>
                                        {disease.scripts.map((script, i) => (
                                          <div
                                            key={i}
                                            className="mb-3"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                              padding: "15px",
                                              borderRadius: "10px",
                                              fontSize: "15px",
                                              color: "#212529",
                                              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                                            }}
                                          >
                                            <p className="mb-0">{script.script_text}</p>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="text-muted">No diseases found.</div>
                            )}
                          </Tab.Pane> */}
                          <Tab.Pane eventKey="Script">
                            {diseases?.length > 0 ? (
                              <>
                                <div className="mb-4 pt-4 px-3 pb-3 ">
                                  <h5 className="mb-2">Select Disease(s) to View Script</h5>
                                  <Select
                                    isMulti
                                    options={diseases.map((d) => ({
                                      value: String(d.disease_id),
                                      label: d.disease_name,
                                    }))}
                                    value={diseases
                                      .filter((d) => selectedDiseaseId.includes(String(d.disease_id)))
                                      .map((d) => ({
                                        value: String(d.disease_id),
                                        label: d.disease_name,
                                      }))
                                    }
                                    onChange={handleDiseaseChange}
                                    placeholder="Choose disease(s)..."
                                    classNamePrefix="select"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        minHeight: "50px",
                                        fontSize: "14px",
                                        borderRadius: "0.5rem",
                                        borderColor: state.isFocused ? "#007bff" : "#ced4da",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                          : "none",
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />

                                  {/* ✅ NEW: Panchkarma Benefits Explained Checkbox */}
                                  <div className="form-check mt-3">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="panchkarmaBenefits"
                                      checked={panchkarmaBenefits}
                                      disabled={panchkarmaLoading}
                                      onChange={(e) => handlePanchkarmaChange(e.target.checked)}
                                    />
                                    <label
                                      className="form-check-label fw-semibold d-flex align-items-center"
                                      htmlFor="panchkarmaBenefits"
                                    >
                                      Panchkarma Benefits Explained
                                      {panchkarmaLoading && (
                                        <span
                                          className="spinner-border spinner-border-sm ms-2"
                                          role="status"
                                          style={{ width: "16px", height: "16px" }}
                                        >
                                          <span className="visually-hidden">Loading...</span>
                                        </span>
                                      )}
                                    </label>
                                  </div>
                                </div>

                                {loadingScripts ? (
                                  <div className="text-center my-4">
                                    <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                  </div>
                                ) : diseaseScripts.length === 0 ? (
                                  <div className="text-muted mt-3">
                                    No scripts found for selected diseases.
                                  </div>
                                ) : (
                                  <div className="mt-3">
                                    {diseaseScripts.map((disease, index) => (
                                      <div key={index} className="mb-4">
                                        <h6 className="fw-bold">{disease.disease_name}</h6>
                                        {disease.scripts.map((script, i) => (
                                          <div
                                            key={i}
                                            className="mb-3"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                              padding: "15px",
                                              borderRadius: "10px",
                                              fontSize: "15px",
                                              color: "#212529",
                                              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                                            }}
                                          >
                                            <p className="mb-0">{script.script_text}</p>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="text-muted">No diseases found.</div>
                            )}
                          </Tab.Pane>

                          <Tab.Pane eventKey="Appointments">
                            <TelecallerAppointmentCalendar
                              leadId={id}
                              // patientId={patientId}
                              // patientId={appointments?.length > 0 ? patientId : undefined}
                              doctorId={latestAppointmentDoctorId} // Default doctor ID, you can make this dynamic if needed
                            />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Questionnaire">
                            <div className="mb-4 pt-4 px-3 pb-3">
                              <h5 className="mb-2">Select Disease(s) for Questionnaire</h5>
                              <Select
                                isMulti
                                options={diseases.map((d) => ({
                                  value: String(d.disease_id),
                                  label: d.disease_name,
                                }))}
                                value={selectedDiseases}
                                onChange={handleDiseaseChange}
                                placeholder="Choose disease(s)..."
                                classNamePrefix="select"
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: "50px",
                                    fontSize: "14px",
                                    borderRadius: "0.5rem",
                                    borderColor: state.isFocused ? "#007bff" : "#ced4da",
                                    boxShadow: state.isFocused
                                      ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                      : "none",
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            </div>

                            {fromLeadsTable &&
                              questionnaireFilledStatus?.toLowerCase() === "no" &&
                              leadDetails?.is_converted === "Converted" && (
                                <div
                                  className="alert alert-warning d-flex align-items-center gap-2"
                                  role="alert"
                                  style={{ marginTop: "2rem" }}
                                >
                                  <span>
                                    This patient has not filled up the form. Kindly ask to fill it up before visiting
                                    doctor.
                                  </span>
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => sendLinkForm(patientId)}
                                  >
                                    Click here to share form link
                                  </button>
                                </div>
                              )}

                            <QuestionnaireComponent
                              leadId={id}
                              onSubmit={handleQuestionnaireSubmit}
                              isConverted={leadDetails?.is_converted === "Converted"}
                              onUnsavedChangesChange={handleUnsavedChangesChange}
                            />
                          </Tab.Pane>

                          <Tab.Pane eventKey="Notes">
                            <Notes></Notes>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Call-logs">
                            <CallLogs leadId={leadId} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Follow-up">
                            <LeadFollowUp />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Marketing-Content">
                            <MarketingContent
                              selectedDiseases={selectedDiseases}
                              onDiseaseChange={handleDiseaseChange}
                            />
                          </Tab.Pane>

                          <Tab.Pane eventKey="Payment">
                            <PaymentDetails></PaymentDetails>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Objection">
                            <div className="p-4 mt-3 ms-3">
                              <h5 className="mb-3">Select Objections</h5>

                              {/* search removed per request */}

                              {objectionsLoading ? (
                                <div className="text-center text-muted">Loading objections...</div>
                              ) : objections.length === 0 ? (
                                <div className="text-muted">No objections found.</div>
                              ) : (
                                (objections.map((obj, index) => {
                                  const label = obj.objection_text || obj.text || "Untitled"
                                  const objId = obj.objection_id || obj.id
                                  const isChecked = selectedPatientObjections.some((s) => (s.objection_id || s.id) === objId)

                                  return (
                                    <div className="form-check mb-2" key={objId || index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`obj-${objId || index}`}
                                        checked={!!isChecked}
                                        disabled={updatingPatientObjections}
                                        onChange={() => handlePatientObjectionChange(obj)}
                                      />
                                      <label htmlFor={`obj-${objId || index}`} className="form-check-label">
                                        {label}
                                        {updatingPatientObjections && isChecked && (
                                          <span className="ms-2">
                                            <span className="spinner-border spinner-border-sm" role="status">
                                              <span className="visually-hidden">Loading...</span>
                                            </span>
                                          </span>
                                        )}
                                      </label>
                                    </div>
                                  )
                                }))
                              )}

                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Unsaved Changes Warning Modal */}
        <Modal
          show={showUnsavedWarning && !questionnaireSubmitted && hasUnsavedChanges}
          onHide={handleCancelNavigation}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Incomplete Questionnaire</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Please complete and submit the questionnaire before moving to the next tab.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCancelNavigation}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleConfirmLeave}>
              Leave Without Submitting
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default ViewLead;
